import React, { useState, useEffect, Fragment } from "react";
import { useHistory } from "react-router-dom";
import { API_URL, scroll, getValFromLS, setValToLS } from "../helpers";
import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Input from "../components/Input";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const CharityRegSubmit = () => {
  const [errors, setErrors] = useState([]);
  const [names, setNames] = useState({
    id: "0",
  });
  const [msg, setMsg] = useState({});
  const [alert, setAlert] = useState({
    type: "working",
    text: "",
  });

  const history = useHistory();

  useEffect(() => {
    scroll();
    init(getValFromLS("crId") || "0");

    // eslint-disable-next-line
  }, []);

  const init = async (id) => {
    const url = new URL(`${API_URL}/crSubmitInit`);
    const params = {
      id,
    };
    url.search = new URLSearchParams(params);

    try {
      const response = await fetch(url, {
        method: "GET",
        cache: "no-store",
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        setNames({ ...json });
        setAlert({});
      } else {
        if (getValFromLS("crId")) {
          setValToLS("crId", "");
        }
        history.push("/registration/info");
      }
    } catch (error) {
      setAlert({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  const handleUpdate = (name, value) => {
    setNames((names) => ({ ...names, [name]: value ? value : "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setMsg({
      type: "working",
      text: "",
    });

    const url = new URL(`${API_URL}/crSubmit`);
    let data = new FormData();
    Object.entries(names).forEach(([key, value]) => {
      data.append(key, value);
    });

    try {
      const response = await fetch(url, {
        method: "POST",
        body: data,
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        setValToLS("crId", "");
        history.push({
          pathname: "/registration/submitted",
          state: {
            id: json.id,
          },
        });
      } else {
        setErrors(json.fields);
        setMsg({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setMsg({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  return (
    <div id="full-column">
      <Hdg section="Registration" />
      <Fragment>
        {alert.type ? (
          <Alert data={alert} />
        ) : (
          <Fragment>
            <h3>
              <i className="fa fa-share-square-o" /> &nbsp;Submit Charity
              Registration
            </h3>
            <p>
              Please submit your completed charity registration details by
              entering your name for signature as your organization’s authorized
              representative. Should you have any questions, please contact{" "}
              <a href="mailto:stephanie@valerotexasopen.com">
                Stephanie@ValeroTexasOpen.com
              </a>{" "}
              or at 210.345.3839.
            </p>

            <form
              method="post"
              action="/"
              onSubmit={(e) => handleSubmit(e)}
              className="well"
            >
              <div className="form-group">
                <Input
                  name="signature"
                  label="Signature of Authorized Representative"
                  reqd={true}
                  value={""}
                  update={handleUpdate}
                  errors={errors}
                  note=""
                />
                <div />
              </div>

              <div className="msg-submit">
                {msg.type && <Msg data={msg} />}

                <div
                  className={
                    msg.type === "working" || msg.type === "success"
                      ? "hidden"
                      : "submit-container"
                  }
                >
                  <Submit
                    path="/registration"
                    left="Back"
                    submit="Submit Charity Registration"
                  />
                </div>
              </div>
            </form>
          </Fragment>
        )}
      </Fragment>
    </div>
  );
};

export default CharityRegSubmit;
